import { render } from "./Topic.vue?vue&type=template&id=ce599132&scoped=true"
import script from "./Topic.vue?vue&type=script&lang=js"
export * from "./Topic.vue?vue&type=script&lang=js"

import "./Topic.vue?vue&type=style&index=0&id=ce599132&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\pzx\\Desktop\\Master\\im\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce599132"]])

export default __exports__